module.exports = __webpack_public_path__ + "static/media/cover.01527395.png";